<template>
    <section class="container bg-white my-5 p-5">

        <time-box v-if="belongsToCheckout" :message="timeBoxText"></time-box>

        <alert v-if="!emailVerified"
               message="Du hast deine E-Mail-Adresse noch nicht bestätigt!<br>
                Um unser Angebot voll und ganz nutzen zu können, brauchst du jedoch eine gültige E-Mail-Adresse."
               actionText="Bestätigungsmail erneut zuschicken"
               actionUrl="verificationEmailResendUrl"
               type="info"
        ></alert>

        <div class="row justify-content-center align-items-top">
            <div class="col-12 order-1 col-md-12 order-md-0">
                <div class="container-fluid">

                    <form name="checkoutReview" :action="nextUrl" v-if="subscription" method="post">
                        <div class="row mb-3">
                            <div class="col-3">
                                <strong class="h5">Dein Auto:</strong>
                            </div>
                            <div class="col-9">
                                {{ subscription.vehicle.filter_attributes.brand  }}<br>
                                {{ subscription.vehicle.filter_attributes.power }} |
                                {{ subscription.vehicle.filter_attributes.fuel }} |
                                {{ subscription.vehicle.filter_attributes.gearing }}<br>
                                Angebots-Nr.: !{ offerId }!
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-3">
                                <strong class="h5">Dein Kilometerpaket:</strong>
                            </div>
                            <div class="col-9">
                                {{ subscription.details.mileage }} km
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-12">
                                <strong class="h5">Mit diesen Leistungen macht dein Auto Abo dein Leben einfach:</strong><br>

                                <ul class="fa-ul">
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> Alle Versicherungen: Vollkasko, Teilkasko und Haftpflicht<br>Selbstbetiligung 1.000 €</li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> Reparaturen,
                                      Verschleiss, Service
                                    </li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> Winterreifen und deren Wechsel</li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> Steuer und Anmeldung</li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> Du zahlst nur Betriebsstoffe</li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> monatlicher Auto-Wechsel oder Kündigung möglich</li>
                                    <li><span class="fa-li"><i class="fas fa-check"></i></span> <strong>Dein All-inclusive-Preis: {{ subscription.vehicle.filter_attributes.price }} €/Monat</strong></li>

                                </ul>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-3">Lieferung nach Hause</div>
                            <div class="col-9">100,--€ (einmalig)</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-3">
                                Gesamt 1. Monat<br>
                                folgende Monate
                            </div>
                            <div class="col-9">
                                {{ parseInt(subscription.vehicle.filter_attributes.price) + 100 }},--€<br>
                                {{ subscription.vehicle.filter_attributes.price }},--€
                            </div>
                        </div>

                        <input type="hidden" name="_token" :value="csrfToken">

                        <div class="row mb-3">
                            <div class="col-auto">
                                <span id="agbAccept"><input type="checkbox" name="agb" id="agb" v-model="checkboxes.agb"> <label for="agb">AGB gelesen und akzeptiert</label></span><br>
                                <span id="privacyAccept"><input type="checkbox" name="privacy" id="privacy" v-model="checkboxes.privacy"> <label for="privacy">Datenschutz gelesen und akzeptiert</label></span>
                            </div>
                        </div>

                        <div class="row">
                            <button v-if="checkboxes.agb && checkboxes.privacy" type="submit" name="submit" class="btn btn-primary col-auto">Jetzt kostenpflichtig abonnieren</button>
                            <button v-else type="submit" name="submit" class="btn btn-primary col-auto" disabled>Jetzt kostenpflichtig abonnieren</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "Overview",
        props: ['belongsToCheckout', 'emailVerified', 'subscriptionData', 'nextUrl', 'csrfToken'],
        data(){
            return {
              timeBoxText: "Grossartig. Nun bist du fast fertig. Bitte überprüfe noch einmal die Daten und schliesse dein Abo final ab.\n" +
                  "Hier findest du noch einmal alle Fakten auf einen Blick.",
                buttonActive: false,
                subscription: false,
                checkboxes: {
                    agb: false,
                    privacy: false
                }
            };
        },
        methods: {
            formSubmit(){
                window.location.href = this.nextUrl;
            },
            parseSubscriptionData(){
                this.subscription = JSON.parse(this.subscriptionData);
                this.subscription.consumer.address.additional = JSON.parse(this.subscription.consumer.address.additional);
                this.subscription.details = JSON.parse(this.subscription.details);
                this.subscription.vehicle.filter_attributes = JSON.parse(this.subscription.vehicle.filter_attributes);
            }
        },
        mounted(){
            this.parseSubscriptionData();
        }
    }
</script>

<style scoped>

</style>
